import list_icon from '@/assets/img/device/mer68/Mer68SE_icon.png'
import { Mer68Max } from './mer68max'
import { KK } from '@/define/define'

export class Mer68SE_JT extends Mer68Max {
  name: string = 'Mer68_SE'
  icon: string = list_icon
  width: number = 672
  fnFactoryKeys: KK[] = [0x100, 0x101, 0x102, 0x103, 0x104, 0x105, 0x106, 0x107, 0x108, 0x109, 0x10a, 0x10b, 0x10c, 0x301, 0x302, 0x20b, 0x20c, 0x403, 0x501, 0x509, 0x50c, 0x50d, 0x50e, 0x40d]
}
